import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "BasketCard";
var classes = {
    actionArea: "".concat(PREFIX, "-action"),
    media: "".concat(PREFIX, "-media"),
    content: "".concat(PREFIX, "-content"),
    pill: "".concat(PREFIX, "-pill"),
    title: "".concat(PREFIX, "-title")
};
var StyledBasketCard = styled(Card, {
    shouldForwardProp: function (prop) { return prop !== "backgroundSize"; }
})(function (_a) {
    var _b;
    var theme = _a.theme, backgroundSize = _a.backgroundSize;
    return (_b = {
            backgroundColor: theme.palette.grey[100],
            boxShadow: "none",
            position: "relative",
            minHeight: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between"
        },
        _b["& .".concat(classes.actionArea)] = {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            justifyContent: "flex-start",
            flex: 1
        },
        _b["& .".concat(classes.media)] = {
            position: "relative",
            height: theme.spacing(20),
            backgroundSize: backgroundSize
        },
        _b["& .".concat(classes.content)] = {
            padding: theme.spacing(3, 1, 1, 1)
        },
        _b["& .".concat(classes.pill)] = {
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.background.paper,
            position: "absolute",
            bottom: 0,
            left: "50%",
            transform: "translate(-50%, 50%)",
            padding: theme.spacing(0.5, 1),
            borderRadius: "10rem",
            border: "1px solid",
            borderColor: theme.palette.primary.main
        },
        _b["& .".concat(classes.title)] = {
            textOverflow: "ellipsis",
            overflow: "hidden",
            maxWidth: "300px",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical"
        },
        _b);
});

export { classes, StyledBasketCard as default };
//# sourceMappingURL=index.styled.js.map
